import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { C2Shape } from '../c2';

interface AuthShellProps {
  children: ReactNode;
  maxWidth?: number;
}

export default function AuthShell({ children, maxWidth = 440 }: AuthShellProps) {
  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Minimal nav: logo → home */}
      <div className="flex items-center" style={{ padding: '22px clamp(32px, 6vw, 96px)' }}>
        <Link to="/" className="flex items-center gap-3 no-underline">
          <div
            className="w-[38px] h-[38px] rounded-[12px] flex items-center justify-center font-mono font-bold text-sm"
            style={{ background: 'var(--accent-soft)', color: 'var(--accent-deep)' }}
          >
            go/
          </div>
          <span className="text-[17px] font-bold tracking-[-0.01em] text-ink">Tidy Go Links</span>
        </Link>
      </div>

      <div
        className="flex items-start justify-center relative"
        style={{ padding: '24px clamp(32px, 6vw, 96px) 96px', minHeight: 'calc(100vh - 160px)' }}
      >
        <C2Shape shape="circle" size={360} color="peach" className="absolute opacity-[0.45]" style={{ top: -80, left: '5%' }} />
        <C2Shape shape="circle" size={280} color="sky" className="absolute opacity-50" style={{ bottom: 40, right: '8%' }} />
        <C2Shape shape="circle" size={120} color="lemon" className="absolute opacity-60" style={{ top: 180, right: '15%' }} />
        <C2Shape shape="circle" size={160} color="mint" className="absolute opacity-[0.55]" style={{ bottom: 180, left: '12%' }} />

        <div
          className="relative w-full bg-surface border border-hairline rounded-xl"
          style={{ maxWidth, padding: 44, boxShadow: 'var(--shadow-lg)' }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
